import React, { useState } from 'react';
import { FiX } from 'react-icons/fi';

const AvatarModal = ({ isOpen, onClose }) => {
  const [imageError, setImageError] = useState(false);
  
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleImageError = (e) => {
    console.error('Failed to load large avatar image:', e.target.src);
    setImageError(true);
  };

  const handleImageLoad = () => {
    setImageError(false);
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4"
      onClick={handleBackdropClick}
    >
      <div className="relative bg-white rounded-xl shadow-xl max-w-md w-full max-h-[90vh] overflow-hidden">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 bg-black bg-opacity-50 text-white rounded-full p-2 hover:bg-opacity-70 transition-all"
          aria-label="Close"
        >
          <FiX size={20} />
        </button>

        {/* Avatar image */}
        <div className="w-full">
          {!imageError ? (
            <img 
              src={`${process.env.PUBLIC_URL}/images/bela-avatar-l.jpeg`}
              alt="Bela"
              className="w-full h-auto object-cover rounded-xl"
              onError={handleImageError}
              onLoad={handleImageLoad}
            />
          ) : (
            // Fallback to small avatar if large one fails
            <img 
              src={`${process.env.PUBLIC_URL}/images/bela-avatar-s2.jpeg`}
              alt="Bela"
              className="w-full h-auto object-cover rounded-xl"
              onError={(e) => {
                console.error('Failed to load fallback avatar image:', e.target.src);
                e.target.style.display = 'none';
              }}
            />
          )}
        </div>
        
        {/* Optional: Add a caption */}
        {/* <div className="p-4 text-center">
          <p className="text-gray-800 font-medium">Bela</p>
          <p className="text-gray-600 text-sm">Your Virtual Companion</p>
          {imageError && (
            <p className="text-xs text-gray-500 mt-1">Using smaller resolution image</p>
          )}
        </div> */}
      </div>
    </div>
  );
};

export default AvatarModal;
